import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Select, SearchBar } from "../../../components";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useWarehouses } from "../hooks";
import { cleanObject } from "../../../helpers/clean-object";

interface ISearchForm {
  search?: string;
  active?: string;
}

export const Warehouses: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const form = useForm<ISearchForm>({
    mode: "all",
    defaultValues: {
      search: searchParams.get("search") ?? "",
      active: searchParams.get("active") ?? "",
    },
  });

  const onSubmit = () => {
    const values = form.getValues();
    navigate({
      pathname: "/warehouses",
      search: `?${createSearchParams(cleanObject(values))}`,
    });
  };

  const where: any = {};
  const search = searchParams.get("search");
  const active = searchParams.get("active");
  if (search) where.search = search;
  if (active) where.active = active === "true";

  const { data, loading } = useWarehouses({ where });

  return (
    <>
      <Header
        title="Entrepôts"
        subtitle="Liste des lieux de stockage"
        buttons={[
          {
            actionText: "Nouvel entrepôt",
            bgColor: "indigo",
            textColor: "white",
            link: `/warehouse/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <SearchBar
          form={form}
          onSubmit={onSubmit}
          placeholder="Rechercher un entrepôt..."
          advancedFilters={
            <Select label="Actif" className="w-full" {...form.register("active")}>
              <option value="">Tous</option>
              <option value="true">Oui</option>
              <option value="false">Non</option>
            </Select>
          }
        />

        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.warehouses?.results?.length ? (
            <EmptyList text="Aucun entrepôt" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Nom</TableCell>
                  <TableCell header>Adresse</TableCell>
                  <TableCell header align="center">
                    Actif
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.warehouses?.results?.map((warehouse) => (
                  <TableRow
                    key={`warehouse-${warehouse.id}`}
                    onClick={() => navigate(`/warehouse/${warehouse.id}`)}
                  >
                    <TableCell>{warehouse.name}</TableCell>
                    <TableCell>{warehouse.address}</TableCell>
                    <TableCell align="center">
                      {warehouse.active ? "Oui" : "Non"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
